export const latinLower = 'abcdefghijklmnopqrstuvwxyz';
export const latinUpper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const cyrillicLower = 'абвгдежзийклмнопрстуфхцчшщъыьэюя';
export const cyrillicUpper = 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ';
export const digits = '0123456789';
export const specials = '!@#$%^&*()_+-=[]{}|;:,.<>?';
//# sourceMappingURL=characters.js.map